





























































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { passwordValidator, checkPasswordValidator, phoneNumberValidator, usernameValidator, nameValidator } from '../../utils/validator'
import SelectRegion from '@/components/Select/SelectRegion.vue'
import SelectPermission from '@/components/Select/SelectPermission.vue'
import api from '../../api'
import BaseClass from '../../virtual-class/baseClass'
import jsencrypt from 'jsencrypt'
@Component({
  components: {
    SelectRegion,
    SelectPermission,
  },
})
export default class CreateUser extends BaseClass {
  private showDialog: boolean = false
  private submitLoading: boolean = false
  private isModify: boolean = false
  private formData: any = {
    name: '',
    nickName: '',
    role: 0,
    pwd: '',
    phone: '',
    address: [],
  }
  private rules = {
    name: [{ validator: usernameValidator, required: true, trigger: 'blur' }],
    nickName: [{ validator: usernameValidator, required: true, trigger: 'blur' }],
    role: [{ required: true, trigger: 'blur', message: '请选择管理区域' }],
    pwd: [],
    phone: [{ validator: phoneNumberValidator, required: true, trigger: 'blur' }],
  }

  public show(formData?: any) {
    if (formData) {
      this.isModify = true
      this.rules.pwd = []
      const { netIdGroupIdList = [] } = formData
      console.log('netIdGroupIdList',netIdGroupIdList)
      let address = []
      if (netIdGroupIdList.length > 0) {
        for (let i = 0; i < netIdGroupIdList.length; i++) {
          const item = netIdGroupIdList[i]
          const { posIdList = [], netId, groupId = [] } = item
          for (let j = 0; j < groupId.length; j++) {
            const group = groupId[j]
            // 将 posIdList(前三位) + netId(第四位) + group(第五位) 组合成完整数组
            const arr = [...posIdList, netId, group]
            address.push(arr)
          }
        }
      }
      console.log(address);
      


      this.formData = {
        name: '',
        nickName: '',
        role: 0,
        pwd: '',
        phone: '',
        ...formData,
        address: address,
      }
    } else {
      this.isModify = false
      this.rules.pwd = [{ validator: passwordValidator, required: true, trigger: 'blur' }] as any
    }
    this.showDialog = true
  }
  public cancel() {
    this.formData = {
      name: '',
      nickName: '',
      role: 0,
      pwd: '',
      phone: '',
      address: [],
    }
    this.showDialog = false
    if ((this.$refs as any).dialogForm) {
      (this.$refs as any).dialogForm.clearValidate()
    }
  }
    private processData(inputData) {
  const result = {};
  for (const item of inputData) {
    const posIdList = item.slice(0, 3); // 前三位posId列表
    const netId = item[3];
    const groupId = item[4];
    if (!result[netId]) {
      result[netId] = { netId, groupId: [], posIdList };
    }
    if (groupId && !result[netId].groupId.includes(groupId)) {
      result[netId].groupId.push(groupId);
    }
    
  }
  return Object.values(result);
  }
  public submitForm(refName: string) {
    (this.$refs as any).dialogForm.validate().then(() => {
      const { pwd = '', name = '', nickName = '', phone = '', address = [], role = 0 } = this.formData || {}
      this.submitLoading = true
      console.log('address',address);
      
      console.log('address',this.processData(address));
      
      let params = {
        role,
        name,
        nickName,
        phone,
        pwd: this.useEncryption(pwd),
        orgId: this.orgInfo.orgId,
        posIdList:Array.from(new Set(address.map((item: any[]) => item[2]))),
        netIdGroupIdList: this.processData(address),
      }
      if (Number(params.role) !== 2) {
        delete params.posIdList
      }
      if (this.isModify) {
        if (!pwd) {
          delete params.pwd
        }
        api.modifyUser(params).then(() => {
          this.$message.success('修改用户成功')
          this.cancel()
          this.$emit('success')
        }).finally(() => {
          this.submitLoading = false
        })
      } else {
        api.addUser(params).then(() => {
          this.cancel()
          this.$message.success('添加用户成功')
          this.$emit('success')
        }).finally(() => {
          this.submitLoading = false
        })
      }
    })
  }
}
